/* eslint-disable */
import React, { Component } from 'react';
import ReactTable from 'react-table';
import PayrollSubComponent from './PayrollSubComponent';

import history from '../../../history';

export default class PayrollTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getTrProps = (state, rowInfo, col, instance) => ({
        onClick: e => {
            const { expanded } = state;
            const { id } = rowInfo.original;
            const path = rowInfo.nestingPath[0];
            const diff = !expanded[path];
            if (diff) {
                this.props.onRowExpand(id);
            } else {
                this.props.onRowCollapse(id);
            }
        },
    });

    fireFetchData = () => {
        this.props.reloadData();
    };

    setExpanded = expanded => ({ [expanded]: true });

    render() {
        const columns = [
            {
                expander: true,
                Expander: ({ isExpanded, ...rest }) => (
                    <div
                        className={`collapsible-table-expander ${
                            isExpanded ? 'active' : ''
                        }`}
                    >
                        <i className="icon icon-arrow-right-12" />
                    </div>
                ),
            },
            {
                Header: '',
                accessor: 'photo_thumbnail_medium',
                sortable: false,
                headerClassName: 'xsmall-col',
                className: 'xsmall-col',
                Cell: row => {
                    const freelancerImg = row.value
                        ? row.value
                        : '/static/images/default_profile.png';
                    return (
                        <div
                            className="avatar"
                            style={{
                                backgroundImage: `url(${freelancerImg})`,
                                borderRadius: '50%',
                                backgroundSize: 'cover',
                                backgroundPosition: '50%',
                                height: '45px',
                                width: '45px',
                                marginTop: '2.5px',
                            }}
                        />
                    );
                },
            },
            {
                Header: 'Name',
                accessor: 'full_name',
                Cell: row => (
                    <a
                        className="group-link"
                        href={`/operations/freelancer/${row.original.id}`}
                    >
                        {row.value}
                    </a>
                ),
            },
            {
                Header: 'Total Scheduled Hours',
                accessor: 'total_scheduled_hours',
            },
            {
                Header: 'Total Worked Hours',
                accessor: 'total_worked_hours',
                Cell: row => {
                    const totalHours = row.value?.toFixed(2);
                    return totalHours % 1 > 0.9
                        ? Math.ceil(totalHours)
                        : totalHours % 1 < 0.1
                        ? Math.floor(totalHours)
                        : totalHours;
                },
            },
            {
                Header: 'No. of Shifts',
                accessor: 'total_bookings',
            },
            {
                Header: 'Total Pay',
                accessor: 'total_pay',
                Cell: row => <span>£{row.value?.toFixed(2)}</span>,
            },
        ];

        const { content } = this.props;
        let pages = -1;
        let showPaginationBottom = false;
        if (content && this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }

        return (
            <ReactTable
                className="table-content"
                loading={this.props.loading}
                data={content || []}
                columns={columns}
                SubComponent={row => (
                    <PayrollSubComponent
                        notification={this.props.notification}
                        table={this.props}
                        match={this.props.match}
                        id={this.props.match.params.id}
                        worker={this.props.content[this.props.expanded]}
                        onRowCollapse={this.props.onRowCollapse}
                        history={history}
                        setRef={this.props.setRef}
                    />
                )}
                getTrProps={this.getTrProps}
                pageSize={content ? content.length : 0}
                noDataText={this.props.errorMsg || 'No Workers Found'}
                showPaginationBottom={showPaginationBottom}
                showPageSizeOptions={false}
                page={this.props.page}
                pages={pages}
                expanded={this.setExpanded(this.props.expanded)}
                onSortedChange={this.props.onSortedChange}
                onPageChange={this.props.onPageChange}
                manual={true}
            />
        );
    }
}
